// extracted by mini-css-extract-plugin
export var wordContainer = "_kg-0";